import { Outlet, NavLink } from "react-router-dom";
import { useState } from "react";
import Sidebar from "../ui/Sidebar";
import Topbar from "../ui/Topbar";

export default function MainLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <div className="min-h-screen bg-slate-50 text-slate-800">
      <Topbar onToggleSidebar={() => setSidebarOpen((v) => !v)} />
      <div className="flex">
        <Sidebar open={sidebarOpen} />
        <main className={`flex-1 transition-all ${sidebarOpen ? "ml-64" : "ml-16"}`}>
          <div className="p-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
